const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  // console.log({value})
  const parts  = value?.split(`; ${name}=`);    
  if (parts.length === 2) return parts.pop().split(';').shift();
};

export function authHeader(){

  // let authToken = JSON.parse(sessionStorage.getItem('accessToken'));
  const authToken = getCookie("tk");
  const authToken1 = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYzOGVmNTBlYjRjNGNmNWJlZjM5NDNiYyIsImVtYWlsIjoiYWRtaW5AZ21haWwuY29tIiwiaWF0IjoxNzg5MDQwNTc0LCJleHAiOjE3ODkyOTk3NzR9.aGibVMPtizLngaPyUKHIz7eAenUGHHEVVtPwyIxMnIc";

  

  // cosole.log("authToken",authToken);

  if(authToken)
    return {'Authorization': authToken};
  else
    return {};
}